module.exports = __webpack_public_path__ + "img/arch_icon2.1339f8d4.png";